import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { WrapperField } from '../../../../../components/InputField/WrapperField';
import { DialogContext } from '../../../../../store/context/DialogContext';
import { useTranslation } from '../../../../../store/context/TranslationContext';
import ButtonGroupNew from '../../BusinessLiteForms/components/ButtonGroupNew';
import { getNextStep, getVisibleWizardFieldOrder, WIZARD, WIZARD_NUM } from '../helper';

const AssetsInvolvement = ({
    asLabel,
    hideButtons,
    data,
    handleUpdate,
    hasError,
    setHasError,
    loading,
    cyclosFields,
    errors,
    setErrors,
    iPlusFields,
    wizard, 
    applicationForm,
    isForEDD,
    handleChange,
    handlePrev,
    setData,
    formType,
    editMode
}) => {
    const { showError } = useContext(DialogContext);
    const { t } = useTranslation();

    const checkNext = () => {
        const visibleFieldOrder = getVisibleWizardFieldOrder({
            fields: iPlusFields,
            wizard,
            data,
        });

        for (const fieldPath of visibleFieldOrder) {
            const fieldError = _.get(errors, fieldPath);
            if (fieldError) {
                setHasError(true);
                if (fieldError) {
                    showError(fieldError);
                    return false;
                }
            }
        }

        setErrors({});
        return true;
    };

    const handleSubmit = () => {
        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            return handleUpdate({ nextStep: getNextStep(wizard, applicationForm, data, editMode) });
        }
    };

    const handleUpdateFormData = (updatedData) => {
        handleChange(updatedData);
    };

    const handleErrors = (field, errorMsg) => {
        setErrors((prevErrors) => {
            const updatedErrors = _.cloneDeep(prevErrors);
            updatedErrors[field] = errorMsg;
            return updatedErrors;
        });
    };

    return (
        <div className="row">
            <div className="col-12">
                <h2 style={{ fontWeight: 'bolder' }} className='pt-3 mb-4'>Cryptocurrency and Digital Assets Involvement</h2>

                <div className='mb-3'>
            
                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["hasLicense"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('hasLicense', errorMsg)}
                        isForEDD={isForEDD}
                    />

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["cryptocurrencyBusinessModel"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('cryptocurrencyBusinessModel', errorMsg)}
                        isForEDD={isForEDD}
                    />


                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["cryptocurrencyBusinessModelOther"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('cryptocurrencyBusinessModelOther', errorMsg)}
                        isForEDD={isForEDD}
                    />


                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["custodiedWallets"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('custodiedWallets', errorMsg)}
                        isForEDD={isForEDD}
                    />

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["cryptocurrencyTypes"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('cryptocurrencyTypes', errorMsg)}
                        isForEDD={isForEDD}
                    />

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["cryptocurrencyTypesOther"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('cryptocurrencyTypesOther', errorMsg)}
                        isForEDD={isForEDD}
                    />

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["cryptoCustodyLicenses"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('cryptoCustodyLicenses', errorMsg)}
                        isForEDD={isForEDD}
                    />
                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["analyticsServices"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        isForEDD={isForEDD}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('analyticsServices', errorMsg)}
                    />
                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["analyticsServicesOther"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        isForEDD={isForEDD}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('analyticsServicesOther', errorMsg)}
                    />

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["cryptoTransactionScreening"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        isForEDD={isForEDD}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('cryptoTransactionScreening', errorMsg)}
                    />

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["cryptoComplianceProgram"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        isForEDD={isForEDD}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('cryptoComplianceProgram', errorMsg)}
                    />

                </div>

                <div className='mt-4'>
                    <ButtonGroupNew
                        onNextClick={handleSubmit}
                        onBackClick={() => { handlePrev() }}
                        step={WIZARD_NUM.AssetsInvolvement}
                        showPageNum={false}
                        pageNum={WIZARD_NUM.AssetsInvolvement}
                        hideSubmitButton={hideButtons}
                        asLabel={false}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    );
};

export default observer(AssetsInvolvement);
